import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private url = environment.apiURL;
  constructor(
    private _http: HttpClienteService, private http: HttpClient
  ) { }

  saveNotificationCustomer(data: any) {
    const query = `${this.url}/wcl-document/upload-customer-notifications`;
    return this._http.post(query, data);
  }
  saveNotificationSeller(data: any) {
    const query = `${this.url}/wcl-document/upload-seller-notifications`;
    return this._http.post(query, data);
  }
  getNotifications(data = { startDate: '', endDate: '' }) {
    const query = `${this.url}/wcl-document/notifications-by-date?startDate=${data.startDate}&endDate=${data.endDate}`;
    return this._http.get(query);
  }


  deleteNotification(data: any) {
    const query = `${this.url}/wcl-document/delete-notification-by-id`;
    return this._http.delete(query, { body: data });
  }
  downloadTemplate(data: any) {
    const query = `${this.url}/wcl-document/presigned-url`;
    return this._http.post(query, data);
  }
 downloadFileFromBlob(preSignedUrl: string): Observable<Blob> {
  return this.http.get(preSignedUrl, {
    responseType: 'blob'
  });
}
}
